import React, { useEffect, useState } from "react";
import "./editClassModal.css";
import { toast } from "react-toastify";
import axios from "axios";
import dummyImage from "../../../Parent/parent-assets/images/about-us-img01.png";
import FadeLoader from "react-spinners/FadeLoader";
import { ReactComponent as CloseIcon } from "../../assets/images/icons/close-icon.svg";
import GymCheerEditor from "./GymCheerEditor";
const EditClassModal = ({
  setProgramClassEditModal,
  className,
  programId,
  programName,
  classId,
  allClassData,
  enrichmentManageClass,
  setEnrichmentManageClass,
  dummayManageProgramData,
  indexNumber,
  setIndexNumber,
  getManageDataFunction,
  selectedClassDetails,
  ModalType,
}) => {
  const [classData, setClassData] = useState();
  const token = localStorage.getItem("access_token");
  const [selectedImage, setSelectedImage] = useState();
  const [selectedFrontPageImage, setSelectedFrontPageImage] = useState();
  const [selectedImageTwo, setSelectedImageTwo] = useState();
  const [images, setImages] = useState([]);
  const [formData, setFormData] = useState({});
  const [convertedImage, setConvertedImage] = useState(null);
  const [convertedHeader, setConvertedHeader] = useState();
  const [description, setDescription] = useState();
  const [longDescription, setLongDescription] = useState();
  const [showLoader, setShowLoader] = useState(false);
  const [frontImage, setFrontImage] = useState();
  const [selectedCheerImage, setSelectedCheerImage] = useState();
  const [cheerImage, setCheerImage] = useState();
  const [editableName, setEditableName] = useState();
  const [cheerGalleryInfo, setCheerGalleryInfo] = useState();
  const [selectedHeaderFile, setSelectedHeaderFile] = useState([]);
  const [baseConvertedImage, setBaseConvertedImage] = useState();
  const [enrichmentComboHeaderImage, setEnrichmentComboHeaderImage] =
    useState();
  const [galleryLoader, setGalleryLoader] = useState();
  const [umberellaName, setUmbrellaName] = useState();
  useEffect(() => {
    if (indexNumber === 0) {
      const desc = allClassData?.filter((item) => item?.id == classId);
      if (desc[0]?.umbrella_name) {
        setUmbrellaName(desc[0].umbrella_name);
      }
      setClassData(desc);
      setDescription(desc?.[0]?.description);
      setLongDescription(desc?.[0]?.description2);
      setEditableName(desc?.[0]?.camp_secondary_name);
    } else if (indexNumber === 1) {
      const desc = dummayManageProgramData?.filter(
        (item) => item?.id == classId
      );
      setDescription(desc?.[0]?.description);
      setLongDescription(desc?.[0]?.description2);
    }
  }, [allClassData]);

  const handleProgramEventFrontImage = async (e) => {
    setSelectedFrontPageImage(e.target.value);
    e.preventDefault();

    try {
      const selectedFiles = e.target.files;
      if (selectedFiles && selectedFiles.length > 0) {
        const file = selectedFiles[0];
        const reader = new FileReader();
        // Create a Promise to wait for the FileReader to load
        const loadPromise = new Promise((resolve) => {
          reader.onloadend = () => {
            resolve();
          };
        });
        // Start loading the file
        reader.readAsDataURL(file);
        // Wait for the FileReader to finish loading
        await loadPromise;

        const img = new Image();
        img.src = reader.result;

        img.onload = () => {
          // Set the desired height and width
          let desiredHeight = 412;
          let desiredWidth = 635;

          const canvas = document.createElement("canvas");
          canvas.height = desiredHeight;
          canvas.width = desiredWidth;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          // Convert the canvas content to a data URL
          const resizedImage = canvas.toDataURL(
            programName === "Camp" || programName === "Enrichment Combos"
              ? "image/png"
              : "image/png"
          );

          // Update state or perform further actions with the resized image
          const convertedFile = {
            image: resizedImage,
          };
          const convertedFileName = {
            name: file.name,
          };
          setImages([convertedFile]);
          setFormData({ ...formData, file: convertedFileName });
          const postBlogImageData = {
            image: resizedImage,
          };
          setFrontImage(postBlogImageData);
        };
      }
    } catch (error) {}
  };

  const handleCheerFrontImage = async (e) => {
    setSelectedCheerImage(e.target.value);
    e.preventDefault();
    try {
      const selectedFiles = e.target.files;
      if (selectedFiles && selectedFiles.length > 0) {
        const file = selectedFiles[0];
        const reader = new FileReader();
        // Create a Promise to wait for the FileReader to load
        const loadPromise = new Promise((resolve) => {
          reader.onloadend = () => {
            resolve();
          };
        });
        // Start loading the file
        reader.readAsDataURL(file);
        // Wait for the FileReader to finish loading
        await loadPromise;

        const img = new Image();
        img.src = reader.result;

        img.onload = () => {
          // Set the desired height and width
          let desiredHeight = 0;
          let desiredWidth = 0;
          if (programName === "Camp") {
            desiredHeight = 412;
            desiredWidth = 600;
          } else {
            desiredHeight = 412;
            desiredWidth = 635;
          }

          const canvas = document.createElement("canvas");
          canvas.height = desiredHeight;
          canvas.width = desiredWidth;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          // Convert the canvas content to a data URL
          const resizedImage = canvas.toDataURL(
            programName === "Camp" || programName === "Enrichment Combos"
              ? "image/png"
              : "image/png"
          );

          // Update state or perform further actions with the resized image
          const convertedFile = {
            image: resizedImage,
          };
          const convertedFileName = {
            name: file.name,
          };
          setImages([convertedFile]);
          setFormData({ ...formData, file: convertedFileName });
          const postBlogImageData = {
            image: resizedImage,
          };
          setCheerImage(postBlogImageData);
        };
      }
    } catch (error) {
      console.error("Error", error);
    }
  };
  const handleProgramEventImage = async (e) => {
    setSelectedImage(e.target.value);
    e.preventDefault();

    try {
      const selectedFiles = e.target.files;
      if (selectedFiles && selectedFiles.length > 0) {
        const file = selectedFiles[0];
        const reader = new FileReader();
        // Create a Promise to wait for the FileReader to load
        const loadPromise = new Promise((resolve) => {
          reader.onloadend = () => {
            resolve();
          };
        });
        // Start loading the file
        reader.readAsDataURL(file);
        // Wait for the FileReader to finish loading
        await loadPromise;

        const img = new Image();
        img.src = reader.result;

        img.onload = () => {
          // Set the desired height and width
          let desiredHeight = 0;
          let desiredWidth = 0;
          if (programName === "Camp") {
            desiredHeight = 412;
            desiredWidth = 600;
          } else {
            desiredHeight = 412;
            desiredWidth = 635;
          }

          const canvas = document.createElement("canvas");
          canvas.height = desiredHeight;
          canvas.width = desiredWidth;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          // Convert the canvas content to a data URL
          const resizedImage = canvas.toDataURL(
            programName === "Camp" || programName === "Enrichment Combos"
              ? "image/png"
              : "image/png"
          );

          // Update state or perform further actions with the resized image
          const convertedFile = {
            image: resizedImage,
          };
          const convertedFileName = {
            name: file.name,
          };
          setImages([convertedFile]);
          setFormData({ ...formData, file: convertedFileName });
          const postBlogImageData = {
            image: resizedImage,
          };
          setConvertedImage(postBlogImageData);
        };
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  useEffect(() => {
    getGalleryInfoData();
  }, []);

  const getGalleryInfoData = async () => {
    try {
      const postData = {
        facility_id: parseInt(classId),
      };
      const responseImage = await axios.post(
        process.env.REACT_APP_BASE_URL + `/admin/get_gallery`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setCheerGalleryInfo(responseImage?.data?.data);
    } catch (error) {
      console.error("Error while generating gallery info.", error);
      toast.error(error);
      // setGalleryLoader(false);
    }
  };

  const editClassProgramHandler = async () => {
    try {
      if (classData?.[0]?.class_type === "weekly") {
        let postData = {
          description: description,
          subprogramdesc2: longDescription,
          subprogramId: parseInt(classId),
          camp_secondary_name: editableName,
        };

        // Add optional fields to postData if they are present
        if (cheerImage) postData.image_page = cheerImage.image;
        if (frontImage) postData.image_front = frontImage.image;
        if (convertedHeader) postData.header_image = convertedHeader.image;
        if (convertedImage) {
          postData.image = convertedImage.image
            ? convertedImage.image
            : filterData?.[0]?.image;
        } else if (!convertedImage && filterData?.[0]?.image) {
          postData.image = filterData[0].image;
        }

        setShowLoader(true);
        const response = await axios.post(
          process.env.REACT_APP_BASE_URL + `/admin/edit-sub-program-cms`,
          postData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response?.status === 200 || response?.status === 201) {
          toast.success("Classes updated successfully.");
          setShowLoader(false);
          setProgramClassEditModal(false);
          setConvertedHeader(null);
          setConvertedImage(null);
          setFrontImage(null);
          setSelectedCheerImage(null);
          setCheerImage(null);
        }
        return;
      }

      if (programName === "Camp") {
        let postData = null;
        if (frontImage && convertedImage && convertedHeader) {
          postData = {
            image_front: frontImage?.image,
            header_image: convertedHeader?.image,
            image: convertedImage?.image
              ? convertedImage?.image
              : filterData?.[0]?.image,
            description: description,
            subprogramdesc2: longDescription,
            subprogramId: classId,
            //  programId: programId,
          };
        } else if (frontImage && convertedImage) {
          postData = {
            image_front: frontImage?.image,
            image: convertedImage?.image
              ? convertedImage?.image
              : filterData?.[0]?.image,
            description: description,
            subprogramdesc2: longDescription,
            subprogramId: classId,
            //  programId: programId,
          };
        } else if (frontImage && convertedHeader) {
          postData = {
            image_front: frontImage?.image,
            header_image: convertedHeader?.image,
            description: description,
            subprogramdesc2: longDescription,
            subprogramId: classId,
            //  programId: programId,
          };
        } else if (frontImage) {
          postData = {
            image_front: frontImage?.image,
            description: description,
            subprogramdesc2: longDescription,
            subprogramId: classId,
            //  programId: programId,
          };
        } else if (convertedImage && convertedHeader) {
          postData = {
            header_image: convertedHeader?.image,
            image: convertedImage?.image
              ? convertedImage?.image
              : filterData?.[0]?.image,
            description: description,
            subprogramdesc2: longDescription,
            subprogramId: classId,
            //  programId: programId,
          };
        } else if (convertedImage) {
          postData = {
            image: convertedImage?.image
              ? convertedImage?.image
              : filterData?.[0]?.image,
            description: description,
            subprogramdesc2: longDescription,
            subprogramId: classId,
            //  programId: programId,
          };
        } else if (convertedHeader) {
          postData = {
            header_image: convertedHeader?.image,
            description: description,
            subprogramdesc2: longDescription,
            subprogramId: classId,
            //  programId: programId,
          };
        } else {
          postData = {
            // header_image:convertedHeader?.image,
            description: description,
            subprogramdesc2: longDescription,
            subprogramId: classId,
            //  programId: programId,
          };
        }

        setShowLoader(true);
        const response = await axios.post(
          process.env.REACT_APP_BASE_URL + `/admin/edit-sub-program-cms`,
          postData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response?.status === 200 || response?.status === 201) {
          toast.success("Classes updated successfully.");
          setShowLoader(false);
          setProgramClassEditModal(false);
        }
      } else if (programName === "Enrichment Combos" && enrichmentManageClass) {
        try {
          let postData = null;
          if (convertedImage && convertedHeader) {
            postData = {
              header_image: convertedHeader?.image,
              image: convertedImage?.image
                ? convertedImage?.image
                : filterData?.[0]?.image,
              description: description,
              description2: longDescription,
              classId: classId,
              programId: programId,
              umbrella_name: umberellaName ? umberellaName : "",
            };
          } else if (convertedImage) {
            postData = {
              image: convertedImage?.image
                ? convertedImage?.image
                : filterData?.[0]?.image,
              description: description,
              description2: longDescription,
              classId: classId,
              programId: programId,
              umbrella_name: umberellaName ? umberellaName : "",
            };
          } else if (convertedHeader) {
            postData = {
              header_image: convertedHeader?.image,
              description: description,
              description2: longDescription,
              classId: classId,
              programId: programId,
              umbrella_name: umberellaName ? umberellaName : "",
            };
          } else {
            postData = {
              // header_image:convertedHeader?.image,
              description: description,
              description2: longDescription,
              classId: classId,
              programId: programId,
              umbrella_name: umberellaName ? umberellaName : "",
            };
          }
          setShowLoader(true);
          const response = await axios.post(
            process.env.REACT_APP_BASE_URL + `/admin/update-combo-class`,
            postData,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response?.status === 200 || response?.status === 201) {
            toast.success("Classes updated successfully.");
            setShowLoader(false);
            setProgramClassEditModal(false);
          }
        } catch (error) {
          toast.error(error);
        }
        setEnrichmentManageClass(false);
        return;
      } else if (programName === "Enrichment Combos") {
        const postData = {
          image: convertedImage?.image,
          categoryId: classId,
          programId: programId,
          description: description,
          description2: longDescription,
          header_image: enrichmentComboHeaderImage?.image,
        };
        setShowLoader(true);
        const response = await axios.post(
          process.env.REACT_APP_BASE_URL +
            `/admin/update_category_cms_foradmin_withNoFk`,
          postData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response?.status === 200 || response?.status === 201) {
          toast.success("Classes updated successfully.");
          setShowLoader(false);
          setProgramClassEditModal(false);
        }
      } else {
        let postData = {
          description: description,
          description2: longDescription,
          classId: classId,
          programId: programId,
          umbrella_name: umberellaName ? umberellaName : "",
        };
        if (frontImage) {
          postData.image_front_class = frontImage?.image;
        }
        if (convertedHeader) {
          postData.header_image = convertedHeader.image;
        }

        if (convertedImage) {
          postData.image = convertedImage.image
            ? convertedImage.image
            : filterData?.[0]?.image;
        }
        setShowLoader(true);
        const response = await axios.post(
          process.env.REACT_APP_BASE_URL + `/admin/update_classes_cms`,
          postData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response?.status === 200 || response?.status === 201) {
          toast.success("Classes updated successfully.");
          setShowLoader(false);
          setProgramClassEditModal(false);
        }
      }
      getManageDataFunction();
      setConvertedHeader(null);
      setConvertedImage(null);
      setFrontImage(null);
      setSelectedCheerImage(null);
      setCheerImage(null);
    } catch (error) {
      setShowLoader(false);
      console.error(error);
    }
  };

  let filterData;
  if (indexNumber === 0) {
    filterData = allClassData?.filter((item) => item?.id == classId);
  } else if (indexNumber === 1) {
    filterData = dummayManageProgramData?.filter((item) => item?.id == classId);
  }

  const handleProgramHeaderImage = async (e) => {
    setSelectedImageTwo(e.target.value);
    e.preventDefault();

    try {
      const selectedFiles = e.target.files;
      if (selectedFiles && selectedFiles.length > 0) {
        const file = selectedFiles[0];
        const reader = new FileReader();
        // Create a Promise to wait for the FileReader to load
        const loadPromise = new Promise((resolve) => {
          reader.onloadend = () => {
            resolve();
          };
        });
        // Start loading the file
        reader.readAsDataURL(file);
        // Wait for the FileReader to finish loading
        await loadPromise;

        const img = new Image();
        img.src = reader.result;

        img.onload = () => {
          // Set the desired height and width

          const desiredHeight = 780;
          const desiredWidth = 1920;

          const canvas = document.createElement("canvas");
          canvas.height = desiredHeight;
          canvas.width = desiredWidth;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          // Convert the canvas content to a data URL
          const resizedImage = canvas.toDataURL(
            programName === "Camp" || programName === "Enrichment Combos"
              ? "image/png"
              : "image/png"
          );
          const postBlogImageData = {
            image: resizedImage,
          };
          setConvertedHeader(postBlogImageData);
          setEnrichmentComboHeaderImage(postBlogImageData);
        };
      }
    } catch (error) {}
  };

  const handleFileChange2 = async (e, index) => {
    e.preventDefault();

    if (
      e.target.value?.split(".")?.[1]?.toLowerCase() === "jpg" ||
      e.target.value?.split(".")?.[1]?.toLowerCase() === "jpeg" ||
      e.target.value?.split(".")?.[1]?.toLowerCase() === "png"
    ) {
      try {
        const selectedFiles = e.target.files;
        if (selectedFiles && selectedFiles?.length > 0) {
          const file = selectedFiles[0];

          setSelectedHeaderFile((prevState) => {
            const tempIndex = [...prevState];
            tempIndex[index] = file?.name;
            return tempIndex;
          });

          const reader = new FileReader();

          // Create a Promise to wait for the FileReader to load
          const loadPromise = new Promise((resolve) => {
            reader.onloadend = () => {
              resolve();
            };
          });

          // Start loading the file
          reader.readAsDataURL(file);

          // Wait for the FileReader to finish loading
          await loadPromise;

          const img = new Image();
          img.src = reader.result;

          img.onload = async () => {
            // Set the desired height and width
            const desiredHeight = 2431;
            const desiredWidth = 3242;

            // Create a canvas element to draw the image with the new dimensions
            const canvas = document.createElement("canvas");
            canvas.height = desiredHeight;
            canvas.width = desiredWidth;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            // Convert the canvas content to a data URL
            const convertedFile = {
              image: canvas.toDataURL("image/jpeg"), // Use 'image/jpeg' for JPEG format
            };

            const convertedFileName = {
              name: file.name,
            };
            setBaseConvertedImage(convertedFile?.image);
          };
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      toast.error(
        `Invalid format of image, image should only be JPEG,PNG and JPG`
      );
      return;
    }
  };

  const galleryImageHandler = async (fk_facilities, id) => {
    try {
      setGalleryLoader(true);
      const postData = {
        image: baseConvertedImage,
        fk_facilities: parseInt(fk_facilities),
        id: id,
      };
      const response = await axios.put(
        process.env.REACT_APP_BASE_URL + `/admin/update_gallery_image`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("Image updated successfully.");
        setSelectedHeaderFile([]);
        setGalleryLoader(false);
        getGalleryInfoData();
      }
    } catch (error) {
      setGalleryLoader(false);
    }
  };
  return (
    <>
      <div
        className="Admin-modal Admin-modal--open"
        id="modalCategory"
        role="dialog"
      >
        <div className="Admin-modal__dialog Admin-modal__dialog--sm">
          <div
            className="Admin-modal__content"
            style={{ width: programName === "Camp" ? "330%" : "280%" }}
          >
            <div className="Admin-modal__head">
              <h2 className="Admin-modal__head--title">{className}</h2>
              <button
                className="Admin-modal__close"
                onClick={() => {
                  setProgramClassEditModal(false);
                }}
              >
                <CloseIcon />
              </button>
            </div>
            <div className="Admin-modal__body">
              <div className="input_formGroup">
                <div className="form__group">
                  <label htmlFor="" className="label">
                    Umbrella Class Name
                  </label>
                  <input
                    type="text"
                    className="form__input"
                    placeholder="Umbrella Class Name"
                    value={umberellaName}
                    onChange={(e) => {
                      setUmbrellaName(e.target.value);
                    }}
                  />
                </div>

                <div className="form__group">
                  <label htmlFor="" className="label">
                    Program Name
                  </label>

                  <input
                    type="text"
                    className="form__input"
                    placeholder="Program Name"
                    value={programName}
                  />
                </div>
                <div className="form__group">
                  <label htmlFor="" className="label">
                    Class Name
                  </label>

                  <input
                    type="text"
                    className="form__input"
                    placeholder="Class Name"
                    value={className}
                  />
                </div>
              </div>

              {showLoader ? (
                <div className="fade_loader_modal_container">
                  <FadeLoader
                    color="#5497c7"
                    cssOverride={{}}
                    height={50}
                    margin={8}
                    radius={9}
                    speedMultiplier={1}
                    width={11}
                  />
                </div>
              ) : (
                <div className="commonList">
                  <div className="commonList__row">
                    <div className="commonList__row__col">
                      <label htmlFor="" className="label">
                        Header Image
                      </label>
                      <div className="cardbox">
                        <div className="browseBox">
                          <div className="browseFile">
                            <div className="browseFile__icon">
                              <svg
                                width="33"
                                height="33"
                                viewBox="0 0 33 33"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                              >
                                <rect
                                  x="0.180664"
                                  width="32.53"
                                  height="32.53"
                                  fill="url(#pattern0)"
                                />
                                <defs>
                                  <pattern
                                    id="pattern0"
                                    patternContentUnits="objectBoundingBox"
                                    width="1"
                                    height="1"
                                  >
                                    <image xlinkHref="data:image/png;base64,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" />
                                  </pattern>
                                </defs>
                              </svg>
                            </div>
                            <h4 className="browseFile__text">
                              Drag files to upload
                            </h4>
                            <p className="browseFile__ortext">or</p>
                            <input
                              className="hiddenInput"
                              id="BrowseFiles-1"
                              type="file"
                              onChange={(e) => handleProgramHeaderImage(e)}
                            />
                            <label for="BrowseFiles-1" className="browseBtn">
                              Browse Files
                            </label>
                            <h6 className="programSelectedFile">
                              {selectedImageTwo?.split("\\")?.pop()}
                            </h6>
                            <div className="browseFileData">
                              <p className="browseFileData__text">
                                Max File Size: <strong>10 MB</strong>
                              </p>
                              <p className="browseFileData__text">
                                Supported file type:{" "}
                                <strong>JPG,PNG,SVG</strong>
                              </p>
                            </div>
                            <div>
                              <img
                                src={
                                  filterData?.[0]?.header_image
                                    ? filterData?.[0]?.header_image
                                    : dummyImage
                                }
                                alt=""
                                className="prevImage"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="commonList__row__col">
                      <label htmlFor="" className="label">
                        Class Image
                      </label>
                      <div className="cardbox">
                        <div className="browseBox">
                          <div className="browseFile">
                            <div className="browseFile__icon">
                              <svg
                                width="33"
                                height="33"
                                viewBox="0 0 33 33"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                              >
                                <rect
                                  x="0.180664"
                                  width="32.53"
                                  height="32.53"
                                  fill="url(#pattern0)"
                                />
                                <defs>
                                  <pattern
                                    id="pattern0"
                                    patternContentUnits="objectBoundingBox"
                                    width="1"
                                    height="1"
                                  >
                                    <image xlinkHref="data:image/png;base64,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" />
                                  </pattern>
                                </defs>
                              </svg>
                            </div>
                            <h4 className="browseFile__text">
                              Drag files to upload
                            </h4>
                            <p className="browseFile__ortext">or</p>
                            <input
                              className="hiddenInput"
                              id="BrowseFiles"
                              type="file"
                              onChange={(e) => handleProgramEventImage(e)}
                            />
                            <label for="BrowseFiles" className="browseBtn">
                              Browse Files
                            </label>
                            <h6 className="programSelectedFile">
                              {selectedImage?.split("\\")?.pop()}
                            </h6>
                            <div className="browseFileData">
                              <p className="browseFileData__text">
                                Max File Size: <strong>10 MB</strong>
                              </p>
                              <p className="browseFileData__text">
                                Supported file type:{" "}
                                <strong>JPG,PNG,SVG</strong>
                              </p>
                            </div>
                            <div>
                              <img
                                src={
                                  filterData?.[0]?.image
                                    ? filterData?.[0]?.image
                                    : dummyImage
                                }
                                alt=""
                                className="prevImage"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {programName === "Cheer" &&
                      classData?.[0]?.class_type !== "weekly" && (
                        <div className="commonList__row__col">
                          <h4 className="label">Front Images:</h4>
                          <div className="cardbox">
                            <div className="browseBox">
                              <div className="browseFile">
                                <div className="browseFile__icon">
                                  <svg
                                    width="33"
                                    height="33"
                                    viewBox="0 0 33 33"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                  >
                                    <rect
                                      x="0.180664"
                                      width="32.53"
                                      height="32.53"
                                      fill="url(#pattern0)"
                                    />
                                    <defs>
                                      <pattern
                                        id="pattern0"
                                        patternContentUnits="objectBoundingBox"
                                        width="1"
                                        height="1"
                                      >
                                        <image xlinkHref="data:image/png;base64,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" />
                                      </pattern>
                                    </defs>
                                  </svg>
                                </div>
                                <h4 className="browseFile__text">
                                  Drag files to upload
                                </h4>
                                <p className="browseFile__ortext">or</p>
                                <input
                                  className="hiddenInput"
                                  id="BrowseFiles-front-img-rec-cheer"
                                  type="file"
                                  onChange={(e) =>
                                    handleProgramEventFrontImage(e)
                                  }
                                />
                                <label
                                  for="BrowseFiles-front-img-rec-cheer"
                                  className="browseBtn"
                                >
                                  Browse Files
                                </label>
                                <div className="browseFileData">
                                  <p className="browseFileData__text">
                                    Max File Size: <strong>10 MB</strong>
                                  </p>
                                  <p className="browseFileData__text">
                                    Supported file type:{" "}
                                    <strong>JPG,PNG,SVG</strong>
                                  </p>
                                </div>
                                <div>
                                  <img
                                    src={classData?.[0]?.image_front_class}
                                    alt=""
                                    className="prevImage"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                    {(programName === "Camp" ||
                      classData?.[0]?.class_type === "weekly") && (
                      <div style={{ display: "flex" }}>
                        <div className="commonList__row__col">
                          <h4 className="label">(Card) Front Image:</h4>
                          <div className="cardbox">
                            <div className="browseBox">
                              <div className="browseFile">
                                <div className="browseFile__icon">
                                  <svg
                                    width="33"
                                    height="33"
                                    viewBox="0 0 33 33"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                  >
                                    <rect
                                      x="0.180664"
                                      width="32.53"
                                      height="32.53"
                                      fill="url(#pattern0)"
                                    />
                                    <defs>
                                      <pattern
                                        id="pattern0"
                                        patternContentUnits="objectBoundingBox"
                                        width="1"
                                        height="1"
                                      >
                                        <image xlinkHref="data:image/png;base64,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" />
                                      </pattern>
                                    </defs>
                                  </svg>
                                </div>
                                <h4 className="browseFile__text">
                                  Drag files to upload
                                </h4>
                                <p className="browseFile__ortext">or</p>
                                <input
                                  className="hiddenInput"
                                  id="BrowseFiles-22"
                                  type="file"
                                  onChange={(e) =>
                                    handleProgramEventFrontImage(e)
                                  }
                                />
                                <label
                                  for="BrowseFiles-22"
                                  className="browseBtn"
                                >
                                  Browse Files
                                </label>
                                <h6 className="programSelectedFile">
                                  {selectedFrontPageImage?.split("\\")?.pop()}
                                </h6>
                                <div className="browseFileData">
                                  <p className="browseFileData__text">
                                    Max File Size: <strong>10 MB</strong>
                                  </p>
                                  <p className="browseFileData__text">
                                    Supported file type:{" "}
                                    <strong>JPG,PNG,SVG</strong>
                                  </p>
                                </div>
                                <div>
                                  <img
                                    src={
                                      filterData?.[0]?.image_front
                                        ? filterData?.[0]?.image_front
                                        : dummyImage
                                    }
                                    alt=""
                                    className="prevImage"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {classData?.[0]?.class_type === "weekly" && (
                          <div className="commonList__row__col">
                            <h4 className="label">Cheer Image:</h4>
                            <div className="cardbox">
                              <div className="browseBox">
                                <div className="browseFile">
                                  <div className="browseFile__icon">
                                    <svg
                                      width="33"
                                      height="33"
                                      viewBox="0 0 33 33"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlnsXlink="http://www.w3.org/1999/xlink"
                                    >
                                      <rect
                                        x="0.180664"
                                        width="32.53"
                                        height="32.53"
                                        fill="url(#pattern0)"
                                      />
                                      <defs>
                                        <pattern
                                          id="pattern0"
                                          patternContentUnits="objectBoundingBox"
                                          width="1"
                                          height="1"
                                        >
                                          <image xlinkHref="data:image/png;base64,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" />
                                        </pattern>
                                      </defs>
                                    </svg>
                                  </div>
                                  <h4 className="browseFile__text">
                                    Drag files to upload
                                  </h4>
                                  <p className="browseFile__ortext">or</p>
                                  <input
                                    className="hiddenInput"
                                    id="BrowseFiles-cheerImage"
                                    type="file"
                                    onChange={(e) => handleCheerFrontImage(e)}
                                  />
                                  <label
                                    for="BrowseFiles-cheerImage"
                                    className="browseBtn"
                                  >
                                    Browse Files
                                  </label>
                                  <h6 className="programSelectedFile">
                                    {selectedCheerImage?.split("\\")?.pop()}
                                  </h6>
                                  <div className="browseFileData">
                                    <p className="browseFileData__text">
                                      Max File Size: <strong>10 MB</strong>
                                    </p>
                                    <p className="browseFileData__text">
                                      Supported file type:{" "}
                                      <strong>JPG,PNG,SVG</strong>
                                    </p>
                                  </div>
                                  <div>
                                    <img
                                      src={
                                        filterData?.[0]?.image_page
                                          ? filterData?.[0]?.image_page
                                          : dummyImage
                                      }
                                      alt=""
                                      className="prevImage"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  {classData?.[0]?.class_type === "weekly" && (
                    <div
                      className="name_editable_container"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                      }}
                    >
                      <h1 className="label">Name:</h1>
                      <input
                        type="text"
                        placeholder="Enter name"
                        className="adminform__input"
                        value={editableName}
                        style={{ width: "30%" }}
                        onChange={(e) => setEditableName(e.target.value)}
                      />
                    </div>
                  )}
                  <div className="commonList__row">
                    <div className="cardbox">
                      <div
                        className="adminform__group"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "20px",
                          marginTop: "20px",
                        }}
                      >
                        <h4 className="label">Short Description:</h4>
                        <textarea
                          className="adminform__textarea"
                          placeholder="write the contents here!"
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                        ></textarea>
                      </div>
                    </div>
                  </div>

                  <div className="commonList__row">
                    <div className="cardbox">
                      <div
                        className="adminform__group"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "20px",
                          marginTop: "20px",
                        }}
                      >
                        <h4 className="label">Long Description:</h4>
                        <textarea
                          className="adminform__textarea"
                          placeholder="write the contents here!"
                          value={longDescription}
                          onChange={(e) => setLongDescription(e.target.value)}
                        ></textarea>
                      </div>
                      <div
                        className="adminbutton__group"
                        style={{ float: "right" }}
                      >
                        <button
                          className="admibtn admibtn-blueOutline"
                          onClick={() => setProgramClassEditModal(false)}
                        >
                          Cancel
                        </button>
                        <button
                          className="admibtn admibtn-primary"
                          onClick={editClassProgramHandler}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <hr />

            {(classData?.[0]?.class_type === "weekly" ||
              programName === "Camp") && (
              <div>
                <div className="commonList">
                  <div
                    className="commonList__row"
                    style={{ padding: "0px 20px" }}
                  >
                    {cheerGalleryInfo?.map((item, index) => (
                      <div className="commonList__row__col" key={item?.id}>
                        <h4 className="label">Gallery Img {index + 1}.</h4>
                        <div className="cardbox">
                          <div className="browseBox">
                            <div className="browseFile">
                              <div className="browseFile__icon">
                                <svg
                                  width="33"
                                  height="33"
                                  viewBox="0 0 33 33"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlnsXlink="http://www.w3.org/1999/xlink"
                                >
                                  <rect
                                    x="0.180664"
                                    width="32.53"
                                    height="32.53"
                                    fill="url(#pattern0)"
                                  />
                                  <defs>
                                    <pattern
                                      id="pattern0"
                                      patternContentUnits="objectBoundingBox"
                                      width="1"
                                      height="1"
                                    >
                                      <image xlinkHref="data:image/png;base64,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" />
                                    </pattern>
                                  </defs>
                                </svg>
                              </div>
                              <h4 className="browseFile__text">
                                Drag files to upload
                              </h4>
                              <p className="browseFile__ortext">or</p>
                              <input
                                className="hiddenInput"
                                id={`BrowseFiles-gal-${index}`}
                                type="file"
                                onChange={(e) => handleFileChange2(e, index)}
                              />
                              <label
                                for={`BrowseFiles-gal-${index}`}
                                className="browseBtn"
                              >
                                Browse Files
                              </label>
                              <h6 className="programSelectedFile">
                                {selectedHeaderFile?.[index]}
                              </h6>
                              <div className="browseFileData">
                                <p className="browseFileData__text">
                                  Max File Size: <strong>10 MB</strong>
                                </p>
                                <p className="browseFileData__text">
                                  Supported file type:{" "}
                                  <strong>JPG,PNG,SVG</strong>
                                </p>
                              </div>
                              {galleryLoader ? (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <FadeLoader
                                    color="#5497C7"
                                    height={21}
                                    margin={1}
                                  />
                                </div>
                              ) : (
                                <div>
                                  <img
                                    src={item?.image}
                                    alt=""
                                    className="prevImage"
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                          <button
                            className="admibtn admibtn-primary"
                            style={{ float: "right", marginTop: "10px" }}
                            onClick={() =>
                              galleryImageHandler(item?.fk_facilities, item?.id)
                            }
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            {classData?.[0]?.class_type === "weekly" && (
              <GymCheerEditor classData={classData} />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default EditClassModal;
